import { createApp } from 'vue';
import { vMaska } from 'maska/vue';
import { Mask } from 'maska';
import App from './App.vue';
import boots from './boots';
import vuetify from './plugins/vuetify';
import router from './router';
import store from './store';

const app = createApp(App);

// Global method to replace VMask filter
app.config.globalProperties.$mask = (value, maskPattern) => {
  if (!value || !maskPattern) return value;
  const mask = new Mask({ mask: maskPattern });
  return mask.masked(value.toString());
};

app.use(store);
app.use(router);
app.use(vuetify);
app.directive('maska', vMaska);

boots({ store, router });

app.mount('#app');
